export default __webpack_public_path__ + "locales/de/DeleteSelfProfileDialog.json?hash=ae88b9abcd4e1c8acb054c189a2694b3";